import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 22 22"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m10.333 14.582 6.079-5.863-.673-.649-5.406 5.215-2.709-2.613-.673.649zm1.37 4.668a8.6 8.6 0 0 1-3.336-.65 8.7 8.7 0 0 1-2.718-1.762 8.3 8.3 0 0 1-1.829-2.619 7.8 7.8 0 0 1-.674-3.216q0-1.71.673-3.218a8.3 8.3 0 0 1 1.828-2.62A8.7 8.7 0 0 1 8.362 3.4a8.6 8.6 0 0 1 3.335-.65q1.774 0 3.336.65a8.7 8.7 0 0 1 2.717 1.762 8.3 8.3 0 0 1 1.83 2.619 7.8 7.8 0 0 1 .674 3.216q0 1.712-.674 3.218a8.3 8.3 0 0 1-1.827 2.62 8.7 8.7 0 0 1-2.715 1.765 8.6 8.6 0 0 1-3.335.65m-.003-.916q3.184 0 5.394-2.132 2.21-2.13 2.21-5.202 0-3.07-2.21-5.202-2.21-2.13-5.394-2.131T6.306 5.798 4.096 11t2.21 5.202q2.21 2.131 5.394 2.131" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }